import { conditionalRender } from '@repo/toolkit/conditional-render'
import InnerBox from '@repo/ui/inner-box'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getHowDidYouHearAboutUs } from '../../../../api/how-did-you-hear-about-us/get-how-did-you-hear-about-us'
import { EnrollmentInput } from '../../../../lib/types/models/enrollment/enrollment-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'

const HowDidYouHearAboutUsEnrollmentForm = () => {
  const form = useFormContext<EnrollmentInput>()

  const { data: howDidYouHearAboutUsOptions } = useQuery({
    queryKey: ['howDidYouHearAboutUsOptions'],
    queryFn: () => getHowDidYouHearAboutUs()
  })

  return (
    <InnerBox className="rounded-2xl">
      <FormField
        control={form.control}
        name="howDidYouHearAboutUsOptionId"
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <ControlledSelectInput
                {...field}
                required
                label={`Comment avez-vous connu LEC ?`}
                options={howDidYouHearAboutUsOptions?.data?.map((option) => ({
                  label: option.name,
                  value: option.id
                }))}
                selectedOption={conditionalRender(!!field.value, {
                  label:
                    howDidYouHearAboutUsOptions?.data?.find((option) => option.id === field.value)
                      ?.name ?? '',
                  value: field.value
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default HowDidYouHearAboutUsEnrollmentForm
